import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { SteeringWheel } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const IMG = "https://images.unsplash.com/photo-1515086828834-023d61380316?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxzdGVlcmluZyUyMHdoZWVsJTIwZGV0YWlsJTIwZHJpdmluZ3xlbnwwfHx8fDE3ODQ1MTEyODl8MA&ixlib=rb-4.1.0&q=85";
const field = "w-full bg-secondary border border-border rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors placeholder:text-muted-foreground";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.error) return toast.error(res.error);
    toast.success("Welcome back!");
    navigate(res.user.role === "admin" ? "/admin" : "/dashboard");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="Driving" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-12 left-12 max-w-sm">
          <h2 className="font-display font-black uppercase tracking-tighter text-4xl leading-none">Drive your future forward.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-24">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <SteeringWheel size={26} weight="fill" className="text-primary" />
            <span className="font-display font-black tracking-tighter uppercase text-sm">Ranchi·Digital Seva</span>
          </Link>
          <h1 className="font-display font-black uppercase tracking-tighter text-4xl">Log in</h1>
          <p className="text-muted-foreground text-sm mt-2 mb-8">Access your applications and track their status.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <input required type="email" data-testid="login-email" className={field} placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input required type="password" data-testid="login-password" className={field} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full py-4 bg-primary text-primary-foreground font-mono text-sm uppercase tracking-widest font-medium rounded-sm hover:bg-primary/90 transition-colors disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-sm text-muted-foreground mt-6">
            No account? <Link to="/register" data-testid="link-register" className="text-primary hover:underline">Create one</Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
